import type { CSSProperties } from 'react'

// Shared layout tokens for the platform-admin directory pages (Schools, Instructors,
// Students, Admins) — kept in one place so the four pages stay visually identical
// without each repeating the same inline style objects.
export const sectionStyle: CSSProperties = {
  background: '#fff', border: '1px solid rgba(27,42,74,0.08)', borderRadius: 14,
  padding: '22px 22px', marginBottom: 20,
}
export const sectionTitleStyle: CSSProperties = { font: '600 15px Inter, sans-serif', color: '#1B2A4A', marginBottom: 14 }
export const rowStyle: CSSProperties = {
  display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0',
  borderBottom: '1px solid rgba(27,42,74,0.05)', flexWrap: 'wrap',
}
export const pageTitleStyle: CSSProperties = { font: '600 26px Lora, serif', color: '#1B2A4A', marginBottom: 6 }
export const pageSubtitleStyle: CSSProperties = { font: '400 14px Inter, sans-serif', color: 'rgba(27,42,74,0.55)', marginBottom: 24 }

export function statusPillStyle(status: 'active' | 'suspended' | 'pending_verification'): CSSProperties {
  return {
    padding: '3px 10px', borderRadius: 20,
    background: status === 'active' ? 'rgba(15,124,108,0.1)' : 'rgba(224,102,59,0.1)',
    color: status === 'active' ? '#0F7C6C' : '#C0522A',
    font: '600 11px Inter, sans-serif',
  }
}
